(function () {
  document.querySelectorAll('section.ndc_related_articles').forEach($block => {
    const $scroller = $block.querySelector('.scroll_wrapper');
    const $bar = $block.querySelector('.progress_bar');
    const $inner = $block.querySelector('.progress_bar_inner');

    if (!$scroller || !$bar || !$inner) {
      return;
    }

    const update = () => {
      const { scrollLeft, scrollWidth, clientWidth } = $scroller;
      const maxScroll = scrollWidth - clientWidth;
      const ratio = scrollWidth ? Math.min(1, clientWidth / scrollWidth) : 1;
      const progress = maxScroll > 0 ? Math.min(1, Math.max(0, scrollLeft / maxScroll)) : 0;

      $inner.style.width = `${ratio * 100}%`;
      $inner.style.transform = `translateX(${progress * (1 / ratio - 1) * 100}%)`;
      $bar.classList.toggle('no_scroll', maxScroll <= 1);
    };

    $scroller.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe($scroller);
    update();
  });
})();